import {
  EnhancedHotSpotData,
  EnhancedHotSpotNodeData,
  EnhancedHotSpotMediaData,
  MediaData,
} from '../../../types/quiz';
import { getQuestion, parseMainExp, parseStringWithNode } from './utils';

/**
 * EnhancedHotSpotData.
 */
export const mapEnhancedHotSpotData = ({
  data,
  mediaData,
}: {
  data: EnhancedHotSpotNodeData;
  mediaData: MediaData<EnhancedHotSpotMediaData[]>;
}): EnhancedHotSpotData => {
  const rawDirection =
    typeof data.directions === 'string'
      ? data.directions
      : (data.directions?.s ?? '');

  const parsedDirections = parseStringWithNode<EnhancedHotSpotMediaData[]>(
    rawDirection,
    mediaData,
  );
  return {
    question: getQuestion<EnhancedHotSpotMediaData[]>(data.q, mediaData),
    mainExplanation:
      parseMainExp<EnhancedHotSpotMediaData[]>(data.e, mediaData) || '',
    directions: parsedDirections,
    answers: data.a.map((answer) => ({
      text: answer.text,
      startOffset: +answer.start,
      endOffset: +answer.end,
    })),
  };
};
